import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined'
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined'
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined'
import * as Permisos from '../utils/Permisos'

// Cada grupo es una sección plegable. `newTo` muestra el botón de alta;
// `writePermisos` lo habilita. Un ítem con `children` se aplana al pintar.
export const navigation = [
    {
        id: 'main',
        label: 'Inicio',
        icon: HomeOutlinedIcon,
        accent: 'accent-blue',
        items: [
            { to: '/resumen', label: 'Resumen', icon: SpaceDashboardOutlinedIcon },
            { to: '/tareas', label: 'Tareas', icon: TaskAltOutlinedIcon, permisos: [Permisos.TAREAS_R] },
            { to: '/calendario', label: 'Calendario', icon: CalendarMonthOutlinedIcon, permisos: [Permisos.CALENDARIO_R] }
        ]
    },
    {
        id: 'operacion',
        label: 'Operación',
        icon: StorefrontOutlinedIcon,
        accent: 'accent-emerald',
        items: [
            { to: '/polizas', label: 'Pólizas', icon: DescriptionOutlinedIcon, permisos: [Permisos.POLIZAS_R], newTo: '/polizas/nuevo', newTooltip: 'Nueva póliza', writePermisos: [Permisos.POLIZAS_W] },
            { to: '/cxc', label: 'Cobranza', icon: PaymentsOutlinedIcon, permisos: [Permisos.POLIZAS_COBRANZA] },
            { to: '/renovaciones', label: 'Renovaciones', icon: AutorenewOutlinedIcon, permisos: [Permisos.POLIZAS_RENOVACIONES] },
            { to: '/siniestros', label: 'Siniestros', icon: ReportProblemOutlinedIcon, permisos: [Permisos.SINIESTROS_R], newTo: '/siniestros/nuevo', newTooltip: 'Nuevo siniestro', writePermisos: [Permisos.SINIESTROS_W] },
            { to: '/cotizaciones', label: 'Cotizaciones', icon: RequestQuoteOutlinedIcon, permisos: [Permisos.COTIZACIONES_R], newTo: '/cotizaciones/nueva', newTooltip: 'Nueva cotización', writePermisos: [Permisos.COTIZACIONES_W] },
            { to: '/prospeccion', label: 'Prospección', icon: ViewKanbanOutlinedIcon, permisos: [Permisos.PROSPECCION_R] }
        ]
    },
    {
        id: 'catalogos',
        label: 'Catálogos',
        icon: MenuBookOutlinedIcon,
        accent: 'accent-violet',
        items: [
            { to: '/clientes', label: 'Clientes', icon: PeopleAltOutlinedIcon, permisos: [Permisos.CLIENTES_R], newTo: '/clientes/nuevo', newTooltip: 'Nuevo cliente', writePermisos: [Permisos.CLIENTES_W] },
            { to: '/prospectos', label: 'Prospectos', icon: PersonSearchOutlinedIcon, permisos: [Permisos.PROSPECTOS_R], newTo: '/prospectos/nuevo', newTooltip: 'Nuevo prospecto', writePermisos: [Permisos.PROSPECTOS_W] },
            { to: '/vendedores', label: 'Vendedores', icon: SupportAgentOutlinedIcon, permisos: [Permisos.VENDEDORES_R], newTo: '/vendedores/nuevo', newTooltip: 'Nuevo vendedor', writePermisos: [Permisos.VENDEDORES_W] }
        ]
    },
    {
        id: 'reportes',
        label: 'Reportes',
        icon: BarChartOutlinedIcon,
        accent: 'accent-amber',
        items: [
            { to: '/reportes/polizas', label: 'Pólizas', icon: ArticleOutlinedIcon, permisos: [Permisos.REPORTES_POLIZAS] },
            { to: '/reportes/recibos', label: 'Recibos', icon: ReceiptLongOutlinedIcon, permisos: [Permisos.REPORTES_RECIBOS] },
            { to: '/reportes/clientes', label: 'Clientes', icon: GroupsOutlinedIcon, permisos: [Permisos.REPORTES_CLIENTES] },
            { to: '/reportes/comisiones', label: 'Comisiones', icon: PercentOutlinedIcon, permisos: [Permisos.REPORTES_COMISIONES] },
            { to: '/automatizaciones', label: 'Automatizaciones', icon: PrecisionManufacturingOutlinedIcon, permisos: [Permisos.REPORTES_AUTOMATIZACIONES] }
        ]
    },
    {
        id: 'administracion',
        label: 'Administración',
        icon: SettingsOutlinedIcon,
        accent: 'accent-rose',
        items: [
            { to: '/aseguradoras', label: 'Aseguradoras', icon: ApartmentOutlinedIcon, permisos: [Permisos.ASEGURADORAS_R] },
            { to: '/monedas', label: 'Monedas', icon: PaidOutlinedIcon, permisos: [Permisos.MONEDA_W] },
            { to: '/claves', label: 'Claves de agente', icon: BadgeOutlinedIcon, permisos: [Permisos.CLAVES_R] },
            { to: '/importar-polizas', label: 'Importar pólizas', icon: DriveFolderUploadOutlinedIcon, permisos: [Permisos.POLIZAS_IMPORT] },
            { to: '/configuracion', label: 'Configuración', icon: TuneOutlinedIcon }
        ]
    }
]

const canSee = (user, permisos) => {
    if (!permisos) return true
    if ((user.rol || []).includes('ROLE_ADMIN')) return true
    return permisos.some((permiso) => (user.permisos || []).includes(permiso))
}

export const matchesRoute = (pathname, to) => pathname === to || pathname.startsWith(`${to}/`)

export const visibleNavigation = (user) => {
    if (!user || !(user.rol || []).includes('ROLE_USER')) return []
    return navigation
        .map((group) => ({
            ...group,
            items: group.items
                .filter((item) => canSee(user, item.permisos))
                .map((item) => ({ ...item, canCreate: canSee(user, item.writePermisos) }))
        }))
        .filter((group) => group.items.length > 0)
}

// Lista plana de destinos para el buscador del header.
export const flattenNavigation = (groups) => groups.flatMap((group) => group.items.flatMap((item) => (
    item.children
        ? item.children.map((child) => ({ to: child.to, label: `${item.label} · ${child.label}`, icon: item.icon, group: group.label || 'General' }))
        : [{ to: item.to, label: item.label, icon: item.icon, group: group.label || 'General' }]
)))
